import { PoolNote, Vault } from '@/types/untangled/pool';
import instance from './untangled-axios';
import instanceV4 from './untangled-axios-v4';
import instanceV2 from './untangled-axiosv2';
import { UseAxiosOptions, useAxios } from '@vueuse/integrations/useAxios';

import { configService } from '@/services/config/config.service';
import QueryString from 'qs';
import { networkId } from '@/composables/useNetwork';
import axios from 'axios';

const instancePrice = axios.create({
  baseURL: 'https://api-dev.untangled.finance',
});
/*
async function getEvents() {
  try {
    const response = await axios.get('/api/v1/event');
    return response.data;
  } catch (error) {
    throw new Error(`API request failed: ${error}`);
  }
}
*/
/*
export function useGetEventApi<T>() {
  const isLoading = ref(false);
  const data = ref<T | any>(null);
  const error = ref<string | null>(null);

  async function fetchData(url: string) {
    isLoading.value = true;
    try {
      const response: AxiosResponse<T> = await axios.get('/api/v1/event');
      data.value = response.data;in
      error.value = null;
    } catch (err: unknown) {
      data.value = null;
      error.value = 'Error fetching data';
    } finally {
      isLoading.value = false;
    }
  }

  return { isLoading, data, error, fetchData };
}
*/
export function useGetPoolEvents() {
  return { data: [], isLoading: false };
  // return useAxios<PoolNote[]>('/api/v1/event', instance);
}

export function useGetPoolLoanAssets(poolId: number | undefined) {
  if (!poolId) {
    return { data: [], isLoading: false };
  }
  return useAxios(`/api/v1/pool/${poolId}/debt-order-contract`, instance);
}

export function useGetPoolInvoiceAssets(poolId: number | undefined) {
  if (!poolId) {
    return { data: [], isLoading: false };
  }
  return useAxios(`api/v1/pool/${poolId}/invoice`, instance);
}

export function useGetPoolNoteTokenAssets(poolId: number | undefined) {
  if (!poolId) {
    return { data: [], isLoading: false };
  }
  return useAxios(`api/v1/pool/${poolId}/note-token-asset`, instance);
}

// export { getEvents };
/**TODO: implement these when we have a properly login*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getCurrentPrice = ({ event = {} as any, pool = {} as any }) => {
  // maybe ready here: import { getCurrentPrice } from '@/lib/utils/asset';
  return { data: { value: [1, 1] } };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPoolsToPay = currencyId => {
  return { data: { value: [] } };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPoolLinkedWallet = poolId => {
  return { data: { value: '' } };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getPoolBalance = function (pool) {
  return { data: { value: 0 } };
};

export const useGetPublicPoolDetail = id => {
  return useAxios(`/api/v1/public/pool/${id}`, instance);
};

export const useGetNoteTokenDetails = tokenAddresses => {
  return instance.post(`/api/v1/tokens/`, { tokenAddresses });
};

export const useGetVaultAssets = vaultAddress => {
  return useAxios(
    `/vault/asset/${vaultAddress}`,
    { method: 'GET' },
    instanceV4
  );
};

export const useGetVaultAssetValue = () => {
  return useAxios(
    `/global-price/portfolio-value`,
    {
      method: 'GET',
    },
    instancePrice
  );
};

export const useGetVaultAPY = () => {
  return useAxios(
    `/global-price/apy`,
    {
      method: 'GET',
    },
    instancePrice
  );
};

export const useGetVaultPrice = () => {
  return useAxios(
    `/global-price/price`,
    {
      method: 'GET',
    },
    instancePrice
  );
};
export const getPoolHistories = poolId => {
  // update pool v2
  // FIXME: check decimal and currency
  // return useAxios(`/api/v1/pool/${poolId}/history`, instance);
  return useAxios(`/api/v2/pool/${poolId}`, instanceV2);
};

export const getVaultPoolHistories = (poolId, chainId) => {
  if (!poolId) {
    return { data: [], isLoading: false };
  }
  // update pool v2
  // FIXME: check decimal and currency
  // return useAxios(`/api/v1/pool/${poolId}/history`, instance);
  return useAxios(
    `/vault/${
      chainId == 99 ? '0x3f48e00cfeba3e713db8bc3e28d634578c553e32' : poolId
    }/transactions/${chainId == 99 ? 137 : chainId}`,
    instanceV4
  );
};

export const getAccountTransactions = (
  poolId: string,
  walletAddress: string
) => {
  return useAxios(
    `/api/v1/pool/${poolId}/transactions/${walletAddress}`,
    instanceV2
  );
};

export const useGetPoolNoteById = noteId => {
  return useAxios<PoolNote>(`/api/v1/event/${noteId}`, instance);
};

export const useGetVaultById = vaultAddress => {
  return useAxios<Vault>(`/vault/${vaultAddress}`, instanceV4);
  // return useAxios<Vault>(
  //   `http://localhost:3000/vault/0x2a68c98bd43aa24331396f29166aef2bfd51343f`
  // );
};

export const useGetInvestmentDetail = (eventId, investor) => {
  return useAxios(
    `/api/v1/event/${eventId}/investment?investor=${investor}`,
    instanceV2
  );
};

export const useGetEventsByInvestor = (
  walletAddress: string,
  options?: UseAxiosOptions
) => {
  return useAxios(`/api/v1/event/wallet/${walletAddress}`, instanceV2, options);
};

export const getInvestmentDetail = async (investor: string) => {
  return (await instanceV2.get(`/api/v2/portfolio?userAddress=${investor}`))
    .data;
};

export const getVaultListByChainId = async (chainId: number) => {
  return (await instanceV4.get(`/vault`)).data;
};

export const useGetPoolValues = poolId => {
  return useAxios(`/api/v1/pool-values?poolId=${poolId}`, instance);
};

export const useGetVaultValues = vaultAddress => {
  let _vault = vaultAddress;
  if (
    vaultAddress == 'CC2IFAZUTR3KISILAK3AN3DYKU3M46USKUF4LM2BVWHWBGG7CWEW3XTR'
  ) {
    _vault = '0x2a68c98bd43aa24331396f29166aef2bfd51343f';
  }
  return useAxios(`/vault/${_vault}/values`, instanceV4);
};

export const useGetPoolMigration = poolId => {
  if (!poolId) {
    return Promise.resolve({ data: [], isLoading: false });
  }
  return useAxios(`/api/v1/pool-migration/${poolId}`, instance);
};

export const useGetVaultMigration = poolId => {
  if (!poolId) {
    return Promise.resolve({ data: [], isLoading: false });
  }
  return useAxios(`/api/v1/vault-migration/${poolId}`, instance);
};
export const getListLegalDocument = async (
  poolId: number,
  category,
  sign,
  publish,
  name
) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND_V2}/api/v3/${poolId}/legal-document` +
        `?${QueryString.stringify({
          category,
          sign,
          publish,
          name,
        })}`
    )
  ).data?.result;
};

export const getLegalDocumentAttachment = async (id: number) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND}/${configService.network.chainId}/api/v1/legal-document/${id}/attachDocument`
    )
  ).data;
};

export const getLegalSignedDocs = async (eventId: number) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND}/${configService.network.chainId}/api/v1/investor/pool-signed-document?eventId=${eventId}`
    )
  ).data;
};

export const getLegalSignedDocAttachment = async (id: number) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND}/${configService.network.chainId}/api/v1/document-signature/${id}/attachDocument`
    )
  ).data;
};

export const getLegalDocumentDetailInfo = async (id: number) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND_V2}/api/v3/legal-document/${id}`
    )
  ).data?.result;
};

export const getPoolDocument = async (payload: {
  noteTokenAddress: string;
  subscriptionNumber: string;
  subscriptionPrice: string;
  currencyInvestment: string;
}) => {
  const response = await instance.post(
    `${configService.env.API_BACKEND}/${networkId.value}/api/v1/investor/pool-document`,
    payload
  );
  return response.data;
};

export const getSignedLegalDocument = async (id: number) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND_V2}/api/v3/signed-legal-document/${id}/view`
    )
  ).data?.result;
};

export const getPoolTokenAssets = async (poolId: number) => {
  return await instance.get(
    `${configService.env.API_BACKEND_V2}/api/v3/${poolId}/note-token-asset`
  );
};
export const downloadLegalDocument = async (id: number) => {
  return (
    await instance.get(
      `${configService.env.API_BACKEND_V2}/api/v3/signed-legal-document/${id}/download`
    )
  ).data?.result;
};

export const postLegalDocumentSign = async (payload: {
  noteTokenAddress: string;
  subscriptionNumber: string;
  subscriptionPrice: string;
  signature: string;
  currencyInvestment: string;
}) => {
  const response = await instance.post(
    `${configService.env.API_BACKEND}/${networkId.value}/api/v1/investor/pool-document/sign`,
    payload
  );
  return response.data;
};

export const getLegalDocumentFile = async (uniqueKey: string) => {
  const response = await instance.get(
    `${configService.env.API_BACKEND}/${networkId.value}/api/v1/investor/pool-document/${uniqueKey}`
  );
  return response.data;
};
